import React, { useContext, useMemo } from 'react';
import { Button, Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
import { useRouter } from 'next/router';
interface ValidateCourseProps {
  isOpen: boolean;
  applicationFeePaidStatus: boolean;
  onClose: () => void;
  onContinue?: () => void;
  onSwitchProgram?: (newCourse: any) => void;
}
const ValidateCourseModal: React.FC<ValidateCourseProps> = ({
  isOpen,
  applicationFeePaidStatus = null,
  onClose,
  onContinue,
  onSwitchProgram
}) => {
  const {
    courses,
    selectedCourseData
  } = useContext(CourseContext);
  const router = useRouter();
  const {
    courseId
  } = router.query;
  const newCourse = useMemo(() => {
    return courses?.find((course: any) => course?._id === courseId);
  }, [courses, courseId]);
  const getModalContent = () => {
    switch (applicationFeePaidStatus) {
      case true:
        return {
          icon: <Image src="/images/registerPage/university.png" alt="success-gif" width={100} height={100} />,
          title: 'Start New Application?',
          message: `You have already applied for course ${selectedCourseData?.name}. As per PW IOI Policy, a student can apply for only one course`,
          goBackText: 'Go Back',
          buttonText: 'View Application'
        };
      case false:
        return {
          icon: <Image src="/images/registerPage/university.png" alt="success-gif" width={100} height={100} />,
          title: 'Start New Application?',
          message: `You have an ongoing application for course ${selectedCourseData?.name}. Would you like to continue or switch to course ${newCourse?.name}?`,
          switchProgramText: 'Switch Program',
          buttonText: 'Continue'
        };
      default:
        return null;
    }
  };
  const content = getModalContent();
  if (!content) return null;
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else {
      onClose();
    }
  };
  return <DialogModal isOpen={isOpen} title="" onClose={onClose} onSubmit={() => null} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showSubmitButton={false} closeOnOutsideClick={false} showCloseIcon={false} size="extra-small" data-sentry-element="DialogModal" data-sentry-component="ValidateCourseModal" data-sentry-source-file="ValidateCourseModal.tsx">
      <div className="flex flex-col items-center gap-4">
        <div>{content.icon}</div>
        <div className="flex flex-col items-center text-center">
          <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="ValidateCourseModal.tsx">
            {content.title}
          </Typography>
          <Typography variant="heading4" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="ValidateCourseModal.tsx">
            {content.message}
          </Typography>
        </div>
        <div className="flex w-full gap-4">
          {applicationFeePaidStatus ? <Button variant="lowFocus" onClick={() => {
          router.push('/');
        }} className="w-1/2">
              {content.goBackText}
            </Button> : <Button variant="lowFocus" onClick={() => {
          onSwitchProgram?.(newCourse);
        }} className="w-1/2">
              {content.switchProgramText}
            </Button>}

          <Button variant="primary" onClick={handleContinue} className="w-1/2" data-sentry-element="Button" data-sentry-source-file="ValidateCourseModal.tsx">
            {content.buttonText}
          </Button>
        </div>
      </div>
    </DialogModal>;
};
export default ValidateCourseModal;